import {gql} from '@apollo/client';


export const ISSUES=gql`
query Issue($projectId:String){
        allIssues(projectId:$projectId){
                id
                issueNumber
                summary
                issue_type
                description
                priority
                resolution
                assignees{
                        id
                        username
                        email
                        profile
                }
                reporter{
                        username
                        email
                        profile
                        id
                }
                status
                attachment
                createdAt
                updatedAt
                Project{
                        name
                        url
                        isActive
                }
        }
}`;
export const ASSIGNED=gql`
query {assignedToMe{
                id
                issueNumber
                summary
                issue_type
                description
                priority
                resolution
                attachment
                assignees{
                        id
                        username
                        email
                        profile
                }
                reporter{
                        username
                        email
                        profile
                        id
                }
                status
                createdAt
                updatedAt
                Project{
                        name
                        url
                        isActive
                }
}}`;
export const ISSUE=gql`
query Issue($issueId:String){
        targetIssue(issueId:$issueId){
                id
                issueNumber
                summary
                issue_type
                description
                priority
                resolution
                attachment
                reporter{
                        username
                        email
                        profile
                        id
                }
                status
                assignees{
                        id
                        username
                        email
                        profile
                }
                createdAt
                updatedAt
                Project{
                        name
                        url
                        isActive
                        id
                }
                Users{
                        username
                        email
                }}
}`;
export const REPORT=gql`
mutation createIssue($input:Fields){
        createIssue(input:$input){
        issue{
                id
                issueNumber
                summary
                issue_type
                description
                priority
                resolution
                attachment
                reporter{
                        username
                        email
                        profile
                        id
                }
                assignees{
                        id
                        username
                        email
                        profile
                }
                status
                createdAt
                updatedAt
                Project{
                        name
                        url
                }
                Users{
                        username
                        email
                }      
                }
                refetch{
                issuesAll{
                        id
                        issueNumber
                        summary
                        issue_type
                        description
                        priority
                        resolution
                        attachment
                        assignees{
                                id
                                username
                                email
                                profile
                        }
                        reporter{
                                username
                                email
                                profile
                                id
                        }
                        status
                        createdAt
                        updatedAt
                        Project{
                                name
                                url
                        }    
                }
}}}`;

export const ASSIGN=gql`
mutation assigne($user:String!, $issue:String!, $project:String!){
        assignUser(user:$user, issue:$issue, project:$project)
        {
                issue{
                        id
                        issueNumber
                        summary
                        issue_type
                        description
                        priority
                        resolution
                        attachment
                        reporter{
                                username
                                email
                                profile
                                id
                        }
                        assignees{
                                id
                                username
                                email
                                profile
                        }
                        status
                        createdAt
                        updatedAt
                        Project{
                                name
                                url
                        }
                        Users{
                                username
                                email
                        }      
                        }
                        refetch{
                                targetIssue(issueId:$issue){
                                        id
                                        issueNumber
                                        summary
                                        issue_type
                                        description
                                        priority
                                        resolution
                                        attachment
                                        reporter{
                                                username
                                                email
                                                profile
                                                id
                                        }
                                        status
                                        assignees{
                                                id
                                                username
                                                email
                                                profile
                                        }
                                        createdAt
                                        updatedAt
                                        Project{
                                                name
                                                url
                                                id
                                        }
                                        Users{
                                                username
                                                email
                                        }}
        }}
}`;

export const ISSUE_LIST=gql`
query {issuesAll{
        id
        issueNumber
        summary
        issue_type
        description
        priority
        resolution
        attachment
        assignees{
                id
                username
                email
                profile
        }
        reporter{
                username
                email
                profile
                id
        }
        status
        createdAt
        updatedAt
        Project{
                name
                url
        }
}}`;
export const EDIT=gql`
mutation editIssue($issueId:String, $input:Edit){
        editIssue(issueId:$issueId, input:$input){
                issue{
                        id
                        issueNumber
                        summary
                        issue_type
                        description
                        priority
                        resolution
                        attachment
                        reporter{
                                username
                                email
                                profile
                                id
                        }
                        assignees{
                                id
                                username
                                email
                                profile
                        }
                        status
                        createdAt
                        updatedAt
                        Project{
                                name
                                url
                        }
                        Users{
                                username
                                email
                        }      
                        }
                        refetch{
                        targetIssue(issueId:$issueId){
                                id
                                issueNumber
                                summary
                                issue_type
                                description
                                priority
                                resolution
                                attachment
                                reporter{
                                        username
                                        email
                                        profile
                                        id
                                }
                                status
                                assignees{
                                        id
                                        username
                                        email
                                        profile
                                }
                                createdAt
                                updatedAt
                                Project{
                                        name
                                        url
                                        id
                                }
                                Users{
                                        username
                                        email
                                }  
                                }
        }}
}`;